// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CC4j6o3C8esKT1eAQR85{align-items:center;gap:10px;padding-top:8px;padding-bottom:12px;padding-left:20px;display:flex}.pUEE6u3Y_XokHvfKDBui{height:24px;font-size:16px;line-height:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search": `CC4j6o3C8esKT1eAQR85`,
	"searchInput": `pUEE6u3Y_XokHvfKDBui`
};
export default ___CSS_LOADER_EXPORT___;
